import { removeUserManager } from "./authentication-service.js";
let userRequested = false;
let numberAuthentication = 0;
const isRequireSignin = (oidcUser, isForce) => isForce || !oidcUser;
export const authenticateUser = (userManager, location, history, user = null) => async (isForce = false, callbackPath = null) => {
  const oidcUser = user !== null ? user : await userManager.getUser();
  if (userRequested) {
    return;
  }
  numberAuthentication++;
  const url = callbackPath || location.pathname + (location.search || '');
  if (isRequireSignin(oidcUser, isForce)) {
    userRequested = true;
    try {
      await userManager.signinRedirect({
        data: {
          url
        }
      });
    } catch (error) {
      removeUserManager();
      throw error;
    } finally {
      userRequested = false;
    }
  } else if (oidcUser !== null && oidcUser !== void 0 && oidcUser.expired) {
    userRequested = true;
    try {
      await userManager.signinSilent();
    } catch (error) {
      if (numberAuthentication <= 1) {
        await userManager.signinRedirect({
          data: {
            url
          }
        });
      } else {
        userRequested = false;
        history.push(`/authentication/session-lost?path=${encodeURI(url)}`);
      }
    }
    userRequested = false;
  }
};
export const logoutUser = async userManager => {
  const oidcUser = await userManager.getUser();
  if (oidcUser) {
    await userManager.signoutRedirect();
  }
};
//# sourceMappingURL=oidc-service.js.map